export const formatPrice = (price = 0, includeCurrency = true, currency = '$') => {
  const data = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
  if (includeCurrency) return `${currency} ${data}`;
  return data;
};

export const getTaxStatus = (status = 0) => {
  switch (status) {
    case -1: return 'NA';
    case 1: return 'Committed';
    case 2: return 'Voided';
    default: return 'Uncommitted';
  }
};

export const getInvoiceStatus = (status = 0) => {
  switch (status) {
    case 1: return 'Submitted';
    case 2: return 'Paid';
    default: return 'Draft';
  }
};

export const getAllInvoiceStatus = () => {
  return [
    {
      value: 0,
      label: 'Draft',
    },{
      value: 1,
      label: 'Submitted',
    },{
      value: 2,
      label: 'Paid',
    },
  ];
}
